<script setup lang="ts">
import AppErrorState from '@/components/app-error-state'
import { DISTRIBUTE_EMPTY_COPY } from '@/constants/distribute'
import type { Emits, Props } from './type'

defineOptions({
  name: 'DistributeFeedState',
})

defineEmits<Emits>()

withDefaults(defineProps<Props>(), {
  compact: false,
})

const stateCopy = {
  chip: DISTRIBUTE_EMPTY_COPY.chip,
  title: DISTRIBUTE_EMPTY_COPY.title,
  description: DISTRIBUTE_EMPTY_COPY.description,
}
</script>

<template>
  <AppErrorState
    v-if="kind === 'error'"
    :variant="compact ? 'inline' : 'full'"
    @retry="$emit('retry')"
  />

  <section v-else class="feed-state" :class="{ 'is-compact': compact }">
    <div class="feed-state__copy">
      <span class="feed-state__chip">{{ stateCopy.chip }}</span>
      <h2>{{ stateCopy.title }}</h2>
      <p>{{ stateCopy.description }}</p>
    </div>
  </section>
</template>

<style scoped>
.feed-state {
  border-radius: 30px;
}

.feed-state__copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feed-state__chip {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.feed-state h2,
.feed-state h3,
.feed-state p {
  margin: 0;
}

.feed-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 72px 24px;
  border: 1px solid var(--distribute-panel-border);
  background: rgba(255, 255, 255, 0.74);
  text-align: center;
}

.feed-state .feed-state__copy {
  align-items: center;
}

.feed-state .feed-state__chip {
  min-height: 32px;
  padding: 0 12px;
  background: rgba(18, 15, 12, 0.05);
  color: var(--distribute-text-soft);
}

.feed-state h2 {
  font-size: 32px;
}

.feed-state p {
  max-width: 420px;
  color: var(--distribute-text-soft);
  line-height: 1.8;
}
</style>
